import React from 'react';

import PaymentList from '../Payment/PaymentList/PaymentList';

export default () => <PaymentList />;
